// MediaBlock.tsx
import React from 'react';
import Image from 'next/image';
import PopupVideo, { PopupVideoData } from '@/components/(features)/surveyWizard/layout/PopupVideo';

export interface MediaBlockProps {
    imageVideoRadioButton?: string;
    video?: PopupVideoData;
    image: {
        sourceUrl: string;
    };
}

const MediaBlock: React.FC<MediaBlockProps> = ({ imageVideoRadioButton, video, image }) => {
    return (
        <div className='flex flex-col items-start'>
            {imageVideoRadioButton === 'video' ? (
                <div className='w-full'>
                    {video?.videoSource === 'upload' && video?.videoFile?.mediaItemUrl ? (
                        <div className='aspect-video w-full overflow-hidden rounded-2xl'>
                            <PopupVideo video={video} />
                        </div>
                    ) : (
                        <PopupVideo
                            video={video}
                            embedClassName='lg:!my-0 rounded-2xl aspect-video overflow-hidden max-xl:!w-full'
                        />
                    )}
                </div>
            ) : (
                image?.sourceUrl && (
                    <Image
                        src={image?.sourceUrl}
                        alt='Survey media'
                        width={600}
                        height={400}
                        className='rounded'
                    />
                )
            )}
        </div>
    );
};

export default MediaBlock;
